import { render, staticRenderFns } from "./SingleBannerCatalog.vue?vue&type=template&id=058db4da&scoped=true"
import script from "./SingleBannerCatalog.vue?vue&type=script&lang=js"
export * from "./SingleBannerCatalog.vue?vue&type=script&lang=js"
import style0 from "./SingleBannerCatalog.vue?vue&type=style&index=0&id=058db4da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058db4da",
  null
  
)

export default component.exports